import ReactDOM from 'react-dom';
// When a donor makes a donation from the project page via AJAX, and we reject that donation because their cart is full,
// render a FullCartLightbox.
//
// This happens in a standalone *Main.js file instead of within a React component because the code that makes the
// request isn't React-based.
//
// See multiProjectGiving.js.

import { FullCartLightbox } from '../common/FullCartLightbox.js';

const renderFullCart = () => {
    const targetDiv = document.getElementById('js-added-to-cart-container');
    // We render a "success" component in this div as soon as you submit your request. If something goes wrong, we have
    // to remove that success message to show the error message.
    ReactDOM.unmountComponentAtNode(targetDiv);
    const setShowFullCartMessage = (shouldShow) => {
        if (!shouldShow) {
            ReactDOM.unmountComponentAtNode(targetDiv);
        }
    };

    ReactDOM.render(
        <FullCartLightbox setShowFullCartMessage={setShowFullCartMessage} showFullCartMessage={true} />,
        targetDiv,
    );
};

// Run as a followup-callback for ajaxAddToCartSubmit.
// If the cart was full, render a FullCartLightbox using the relevant div.
export const fullCartCheck = (data) => {
    // Keep in sync with addtocart.donation.AjaxResponseType
    if (data && data.reason === 'FULL_CART') {
        renderFullCart();
    }
};
